import gql from 'graphql-tag'

export default gql`
    mutation insight($UserID: String, $InsightID: String, $Action: String!, $Data: String!) {
        insight(UserID: $UserID, InsightID: $InsightID, Action: $Action, Data: $Data)
    }
`
